<template>
  <v-row wrap >
    <v-col id="requestAccessEmployeesDetails">
      <v-list
        two-line
        v-if="invalidEmployees && invalidEmployees.length > 0"
      >
        <template v-for="(employee) in invalidEmployees">
          <v-list-group
            :sub-group="$vuetify.breakpoint.smAndUp"
            :no-action="$vuetify.breakpoint.smAndUp"
            :key="employee._id"
            :value="false"
            :v-if="
              $store.state.auth.user.roles[0] !=
              $store.state.constants.roles.SECURITY
            "
          >
            <v-list-item slot="activator" >
              <v-list-item-action>
                <v-col>
                  <v-icon color="primary">people</v-icon>
                  <v-badge overlap bordered color="error" v-if="invalidEmployees.length > 0">
                    <span slot="badge">{{
                      getDelayedEmployeeObligations(employee).length + countMissingItems(employee)}}
                    </span>
                  </v-badge>
                </v-col>
              </v-list-item-action>
              <v-list-item-content :key="employee._id" style="max-width: 220px;">
                <v-list-item-title>
                  {{ employee.firstName }}
                  &nbsp;
                  {{ employee.lastName }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ `${employee.identifier.type.toUpperCase()} ` }}
                  {{ employee.identifier.number }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <request-access-p-p-i-details
              :invalidEmployeesPPIList="getEmployeePersonalProtectionItemsList(employee)"
              @viewComment="$emit('viewComment', $event)"
            ></request-access-p-p-i-details>
            <request-access-obligations-details
              :obligations="getDelayedEmployeeObligations(employee)"
              @viewComment="$emit('viewComment', $event)"
            ></request-access-obligations-details>
            <v-divider></v-divider>
          </v-list-group>
        </template>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
"use strict";

import requestAccessObligationsDetails from "./request-access-obligations-details.view.vue";
import requestAccessPPIDetails from "./request-access-p-p-i-details.view.vue";

export default {
  name: "requestAccessEmployeesDetails",
  components: {
    requestAccessObligationsDetails,
    requestAccessPPIDetails,
  },
  data() {
    return {
      value: [],
    };
  },
  methods: {
    countMissingItems(employee) {
      let missingPPIList = JSON.parse(JSON.stringify(this.invalidEmployeesPPIList))
      let employeePPICount;
      Object.entries(missingPPIList).forEach(([employeeId, employeePPI]) => {
        if (employeeId == employee._id) {
          employeePPICount = employeePPI
        }
      })
      return employeePPICount.length;
    },
    getDelayedEmployeeObligations(employee) {
      const delayedEmployeeObligations = this.delayedEmployeeObligations &&
      this.delayedEmployeeObligations.filter(o => o.referenceId == employee._id);
      return delayedEmployeeObligations; 
    },
    getEmployeePersonalProtectionItemsList(employee) {
      let missingPPIList = JSON.parse(JSON.stringify(this.invalidEmployeesPPIList))
      let employeePPIList;
      Object.entries(missingPPIList).forEach(([employeeId, employeePPI]) => {
        if (employeeId == employee._id) {
          employeePPIList = employeePPI
        }
      })
      return employeePPIList;
    }
  },
  props: {
    invalidEmployees: { type: Array },
    delayedEmployeeObligations: { type: Array },
    invalidEmployeesPPIList: { type: Object },
    visit: { type: Object },
  },
};
</script>
